export const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'] as const

export type Day = (typeof days)[number]

export function isToday(day: Day): boolean {
  return days[new Date().getDay()] === day
}
